<section class="verificacao-seguranca-identificacao">
  <img src="assets/images/verify_valid_user.svg" width="160" alt="selfie" />

  <div class="verificacao-seguranca-identificacao__title">Identificação</div>

  <p>Primeiro, precisamos confirmar seus dados pessoais</p>

  <form [formGroup]="form" class="forms">
    <div class="row">
      <div class="col-xs-12">
        <span for="cpf">Digite o seu <strong>CPF</strong></span>
        <input
          class="form-control"
          type="text"
          placeholder="Digite somente os números"
          required
          mask-number
          [mask]="'000.000.000-00'"
          appCpfValidator
          appShowErrorMessages
          requiredMessage="O campo CPF é obrigatório"
          formControlName="cpf"
          name="cpf"
        />
      </div>
    </div>
  </form>
</section>
